<template>
  <v-container class="db-tableau">
    <div class="db-actions">
      <v-btn small depressed color="primary" :loading="refreshing" :disabled="!vizReady" @click="refreshData">
        {{ label }}
      </v-btn>
    </div>
    <p v-if="url==='' || token===''">Loading...</p>
    <div ref="tableauViz" style="width: 100%; height: 827px;"></div>
  </v-container>
</template>
<script>

// IframeDashboard.vue 的副本，只给 v2.3 看板用（分流见 DashboardSelector.vue）。
// 多了两样：
//   - 「刷新数据」按钮：调 refreshDataAsync()，绕过 Tableau 查询缓存重查一次（不会刷新数据源本身）。
//   - REFRESH_ON_OPEN：打开时带 :refresh=yes 直接用最新数据渲染，默认关闭。
// 背景：Tableau 对 extract 看板的查询缓存不随数据源更新失效，客户可能看到落后几小时的数据（2026-10-28 实测）。
import {getTableauToken} from "../api/routes";
import {TableauViz, TableauEventType} from '../../public/tableau.embedding.3.min.js';

const REFRESH_ON_OPEN = false;

const LABELS = {zh: '刷新数据', fr: 'Actualiser les données', en: 'Refresh data'};

export default {
  name: "IframeDashboardFresh",
  data: () => ({
    url: '',
    token: '',
    hideTabs: false,
    viz: null,
    vizReady: false,
    refreshing: false,
  }),
  computed: {
    label() {
      const lang = (navigator.language || navigator.userLanguage || '').toLowerCase();
      if (lang.indexOf('zh') === 0) return LABELS.zh;
      if (lang.indexOf('fr') === 0) return LABELS.fr;
      return LABELS.en;
    },
  },
  methods:{
    redirectToList: function (){
      this.$router.push("/list");
    },
    init: function (){
      this.$nextTick(function () {
        const viz = new TableauViz();
        if (REFRESH_ON_OPEN) {
          // custom-parameter 必须在设 src 之前加
          const p = document.createElement('custom-parameter');
          p.setAttribute('name', ':refresh');
          p.setAttribute('value', 'yes');
          viz.appendChild(p);
        }
        viz.src = "https://dub01.online.tableau.com/t/cypheme/views/"+this.url;
        viz.token = this.token;
        viz.toolbar = 'hidden';
        viz.hideTabs = this.hideTabs;
        viz.addEventListener(TableauEventType.FirstInteractive, () => { this.vizReady = true; });
        this.viz = viz;
        this.$refs.tableauViz.appendChild(viz);
      });
    },
    refreshData: function (){
      if (!this.viz || this.refreshing) return;
      this.refreshing = true;
      this.viz.refreshDataAsync()
        .catch(error => console.log(error))
        .finally(() => { this.refreshing = false; });
    },
  },
  mounted() {
    try {
      this.url = JSON.parse(sessionStorage.getItem('USER')).user.url.trim();
      if(this.url === '')
        this.redirectToList()

      let user_data = JSON.parse(sessionStorage.getItem('USER'))
      if (user_data.user.htabs !== undefined && user_data.user.htabs) {
        this.hideTabs = false;
      }

      getTableauToken().then(resp => {
        this.token = resp.data.token;
        this.init();
      }).catch(error => {
        console.log(error)
      });

    } catch (e) {
      this.redirectToList()
    }
  }
}
</script>
<style scoped>
.container.db-tableau {
  padding: 0;
  margin: 0;
}
.db-actions {
  display: flex;
  justify-content: flex-end;
  padding: 4px 8px;
}
</style>
